<div
  class="floating-panel"
  [class.floating-panel-minimized]="isMinimized"
  cdkDrag
  (cdkDragEnded)="onDragEnded($event)"
  [cdkDragFreeDragPosition]="panelData.position"
  [style.width.px]="isMinimized ? null : panelData.size.x"
  [style.height.px]="isMinimized ? null : panelData.size.y"
  [style.zIndex]="zIndex">

  <div class="floating-panel-header" cdkDragHandle *ngIf="isMinimized">
    <div class="floating-panel-title" [title]="title">
      {{ title }}
    </div>

    <div class="floating-panel-actions">
      <bringoz-button
        type="tertiary"
        size="fit"
        [title]="isMinimized ? 'Expand' : 'Minimize'"
        (onClick)="toggleMinimize($event)">
        <bringoz-icon iconName="expand" class="secondary-100"></bringoz-icon>
      </bringoz-button>

      <bringoz-button
        type="tertiary"
        size="fit"
        title="Close"
        (onClick)="onClose.emit()">
        <bringoz-icon iconName="close" class="secondary-100"></bringoz-icon>
      </bringoz-button>
    </div>
  </div>

  <div class="floating-panel-handle-wrapper" *ngIf="!isMinimized">
    <div class="floating-panel-drag-handle" cdkDragHandle [style.--grab-handle-margin]="grabHandleMargin"></div>
  </div>

  <div class="floating-panel-content" *ngIf="!isMinimized">
    <ng-content></ng-content>
  </div>

  <div
    *ngIf="!isMinimized"
    class="floating-panel-resize-handle"
    title="Resize"
    (mousedown)="startResize($event)">
  </div>
</div>
